import { render, staticRenderFns } from "./image-component.vue?vue&type=template&id=8182af96&scoped=true&"
import script from "./image-component.vue?vue&type=script&lang=js&"
export * from "./image-component.vue?vue&type=script&lang=js&"
import style0 from "./image-component.vue?vue&type=style&index=0&id=8182af96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8182af96",
  null
  
)

export default component.exports